var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAutoDepart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3640_25653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 11V11.5H1.33203V11H0.332031ZM1.33203 11C1.33203 5.65675 5.66359 1.3252 11.0068 1.3252V0.325195C5.1113 0.325195 0.332031 5.10447 0.332031 11H1.33203ZM11.0068 1.3252C13.9646 1.3252 16.612 2.65187 18.3874 4.74439L19.15 4.09742C17.1926 1.79053 14.2706 0.325195 11.0068 0.325195V1.3252Z",
    fill: "#3AB54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4318 6.5021L17.514 5.40177L19.9258 3.42505L20.4318 6.5021Z",
    fill: "#3AB54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4141 11V10.5H20.4141V11H21.4141ZM20.4141 11C20.4141 16.3432 16.0825 20.6748 10.7393 20.6748V21.6748C16.6348 21.6748 21.4141 16.8955 21.4141 11H20.4141ZM10.7393 20.6748C7.78149 20.6748 5.13408 19.3481 3.35866 17.2556L2.59614 17.9026C4.55345 20.2095 7.47548 21.6748 10.7393 21.6748V20.6748Z",
    fill: "#3AB54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29285 15.4961L4.2597 16.572L1.8445 18.6034L1.29285 15.4961Z",
    fill: "#3AB54A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0103,
    cy: 11.0001,
    r: 7.46347,
    fill: "url(#paint0_linear_3640_25653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1725 4.23962C12.3795 3.40096 10.3268 3.3089 8.46597 3.98371C6.60511 4.65852 5.08854 6.04492 4.24987 7.83791C3.41121 9.63089 3.31916 11.6836 3.99397 13.5445C4.66878 15.4053 6.05517 16.9219 7.84816 17.7606L11.0103 11.0001L14.1725 4.23962Z",
    fill: "url(#paint1_linear_3640_25653)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0087,
    cy: 10.9999,
    r: 5.86415,
    fill: "url(#paint2_linear_3640_25653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.264 14.2055L14.6816 9.78779L13.5479 8.65405L10.2444 11.9575L8.60247 10.3156L7.48828 11.4298L10.264 14.2055Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3640_25653",
    x1: 18.4738,
    y1: 3.53662,
    x2: 3.54688,
    y2: 18.4636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AAB2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FE963"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3640_25653",
    x1: 18.4738,
    y1: 3.53662,
    x2: 3.54688,
    y2: 18.4636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48DC5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30BB42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3640_25653",
    x1: 16.8728,
    y1: 5.13574,
    x2: 5.14453,
    y2: 16.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AB920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BED6E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3640_25653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAutoDepart);
export default __webpack_public_path__ + "static/media/ic-auto-depart.455848dc8eec3d02ff2f3bda84cb6ab1.svg";
export { ForwardRef as ReactComponent };